var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 4,
    viewBox: "0 0 20 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.823223 2.17678C0.725592 2.07915 0.725592 1.92085 0.823223 1.82322L2.41421 0.232233C2.51184 0.134602 2.67014 0.134602 2.76777 0.232233C2.8654 0.329864 2.8654 0.488155 2.76777 0.585786L1.35355 2L2.76777 3.41421C2.8654 3.51184 2.8654 3.67014 2.76777 3.76777C2.67014 3.8654 2.51184 3.8654 2.41421 3.76777L0.823223 2.17678ZM20 2.25H1V1.75H20V2.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.be67c093e73f3d33f0a7acf325cfbf8c.svg";
export { ForwardRef as ReactComponent };